import { Injectable } from '@angular/core';
import { createStore } from '@ngneat/elf';
import { addEntities, getEntity, updateEntities, upsertEntities, withEntities } from '@ngneat/elf-entities';
import {
    PaginationData,
    selectCurrentPageEntities,
    selectPaginationData,
    setCurrentPage,
    setPage,
    updatePaginationData,
    withPagination
} from '@ngneat/elf-pagination';
import { ISimplePeriodic } from '../models/book';
import { HttpPaginationResponseI } from '../models/http';

const store = createStore({ name: 'adminPeriodic' }, withEntities<ISimplePeriodic>(), withPagination());

@Injectable({ providedIn: 'root' })
export class AdminPeriodicRepository {
    periodicsOnCurrentPage$ = store.pipe(selectCurrentPageEntities());
    selectCurrentPaginationData$ = store.pipe(selectPaginationData());
    currentMagazineId: number;

    getPeriodicById(id: number): ISimplePeriodic {
        return store.query(getEntity(id));
    }

    updatePeriodic(payload: ISimplePeriodic): void {
        store.update(updateEntities(payload.id, { ...payload }));
    }

    addPeriodic(payload: ISimplePeriodic): void {
        store.update(addEntities(payload));
    }

    addPaginationPeriodics(magazineId: number, paginationResponse: HttpPaginationResponseI<ISimplePeriodic[]>): void {
        this.currentMagazineId = magazineId;
        store.update(
            upsertEntities(paginationResponse.content),
            updatePaginationData({
                currentPage: paginationResponse.number,
                perPage: paginationResponse.size,
                total: paginationResponse.totalElements,
                lastPage: paginationResponse.totalPages
            }),
            setPage(
                paginationResponse.number,
                paginationResponse.content.map(c => c.id)
            ),
            setCurrentPage(paginationResponse.number)
        );
    }

    updatePagination(magazineId: number, page: number, ids: number[], paginationData: PaginationData): void {
        this.currentMagazineId = magazineId;
        store.update(updatePaginationData(paginationData), setPage(page, ids), setCurrentPage(page));
    }
}
